var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ErrorBox = function (_a) {
    var children = _a.children;
    return (_jsx("div", __assign({ className: "m-5 flex text-red-800 flex-row items-center bg-red-200 p-3 rounded border-b-2 border-red-300" }, { children: children ? (children) : (_jsxs(_Fragment, { children: ["Oops. Something unexpected happened.", _jsx("br", {}, void 0), "Try to reload the page."] }, void 0)) }), void 0));
};
export default ErrorBox;
